import React, { useCallback, useRef } from 'react';
import { useParams } from 'react-router-dom';

import { useToken } from '../../../shared/hooks';
import { useWebViewLoading } from '../../../shared/hooks/useWebViewLoading';
import { postMessageToFlutter } from '../../../shared/services/bridge';
import { useEnquete } from '../hooks';

import './SurveyScreen.css';

/**
 * アンケート画面
 *
 * LimeSurvey を iframe で表示する。
 * APIから取得したURLをiframeのsrcに設定。
 * アンケートは1ページ固定のため、2回目のiframe loadで送信完了と判定する。
 */
const SurveyScreen: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const token = useToken();

  const { enqueteUrl, isLoading, error } = useEnquete(id || '', token);

  const contentRef = useWebViewLoading(isLoading);
  const iframeLoadCount = useRef(0);

  const handleIframeLoad = useCallback(() => {
    iframeLoadCount.current += 1;
    if (iframeLoadCount.current >= 2) {
      postMessageToFlutter('surveyCompleted');
    }
  }, []);

  if (isLoading) {
    // Flutterオーバーレイローディングを表示するため、空のコンテナを返す
    return <div ref={contentRef} className="survey-container" />;
  }

  if (error || !enqueteUrl) {
    return (
      <div ref={contentRef} className="survey-container">
        <main className="survey-error">
          <p className="survey-error-message">
            {error || 'アンケートを読み込めませんでした'}
          </p>
        </main>
      </div>
    );
  }

  return (
    <div ref={contentRef} className="survey-container">
      <iframe
        src={enqueteUrl}
        title="アンケート"
        className="survey-iframe"
        onLoad={handleIframeLoad}
      />
    </div>
  );
};

export default SurveyScreen;
